'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import moment from "moment";

import Button from 'react-bootstrap/Button';
import ButtonToolbar from "react-bootstrap/ButtonToolbar";

import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import planItemStore from "@uw-it-sis/lib-react-myplan/lib/PlanItemStore";
import {getGeneralPlaceholderName} from "@uw-it-sis/lib-react-myplan/lib/GeneralPlaceHolderConstants";

import {DateFormatString} from "../lib/Constants";

/**
 * Placeholder summary popover widget.
 */
function PlaceholderSummaryWidget(props) {

    /**
     * Click handler for the "add to plan" button for adding a recommended placeholder.
     */
    const handleAddRecommendedToPlanClick = () => {
        planItemStore.acceptRecommendation(props.item.planItemDataObject.id);
        handleCloseClick();
    };

    /**
     * Callback to the parent component when the cancel link is clicked.
     */
    const handleCloseClick = () =>{
        props.onCancel();
    };

    /**
     * Build the modal body
     * @returns {*}
     */
    const getModalBody = () => {
        let planItem = props.item;

        let placeHolderName = getGeneralPlaceholderName(planItem.placeHolderCode, planItem.placeHolderValue);

        let placeHolderCredit = planItem.placeHolderCredit ? `(${planItem.placeHolderCredit})` : null;

        let placeholder =
            <p className="lead">
                <strong>{placeHolderName} {placeHolderCredit}</strong>
            </p>;

        let messagesWidget =
            <p>
                {planItem.adviserName} recommended this on {moment(planItem.planItemDataObject.dateAdded).format(DateFormatString)}
            </p>;

        let noteBody = null;
        if ( planItem.note && planItem.note !== "" ) {
            noteBody =
                <p className="fst-italic">
                    {planItem.note}
                </p>;
        }

        let buttons = null;
        if (appStore.isAuthenticated() && ! appStore.isAdviser()) {
            buttons =
                <ButtonToolbar className="justify-content-end">
                    <Button variant="primary" onClick={handleAddRecommendedToPlanClick}>Add to Plan</Button>
                    <Button variant="secondary" onClick={handleCloseClick}>Close</Button>
                </ButtonToolbar>;
        }

        return (
           <>
               {placeholder}
               {messagesWidget}
               {noteBody}
               {buttons}
           </>
        )
    };

    return getModalBody();

}

PlaceholderSummaryWidget.propTypes = {
    item: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired
};

export default PlaceholderSummaryWidget;
